<template>
    <div v-if="!show">
        <policyHeader/>
        <div class="bannerBox">
            <a-carousel :dot-position="bottom">
                <div>
                    <img class="bannerImg" src="../img/jidi.jpg"/>
                </div>
            </a-carousel>
        </div>
        <div style="width: 100%;background-color: #fff;">
            <div class="breadBox">
                <a-breadcrumb>
          <span>
            <img src="@/assets/img/position.png"/>
            当前位置：
          </span>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item>双创基地</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
            <FilterInfo :list="getFilterInfo" @changeValue="getFilterSearch($event)"/>
            <div class="tabBox">
                <a-list item-layout="vertical" size="large" :data-source="dataSource">
                    <template #renderItem="{ item }">
                        <div class="listBox">
                            <div class="leftBox">
                                <img v-if="item.baseLogo" :src="getImg(item.baseLogo)" alt="">
                                <img v-else src="@/assets/img/defaultPhotoLong.png" alt="">
                            </div>
                            <div class="right">
                                <div class="title">{{ item.baseName }}</div>
                                <div class="time">
                                    <FieldTimeOutlined/>
                                    <span>地址:{{ item.baseAddress }}</span>
                                </div>
                                <div class="content" v-html="item.baseDescription"></div>
                                <div>
                                    <button class="btn" @click="onMore(item.id)">了解更多</button>
                                </div>
                            </div>
                        </div>
                    </template>
                </a-list>
            </div>
        </div>
        <LayoutFooter />
    </div>
<!--    <policyDetail v-if="show" :policyId="policyId" @changeMsg="changeMsg"/>-->
</template>
<script>

import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2'
import {file_service} from "@/api/adminService";
import {base} from "@/api/innovationService";
import {getDistMixin, listMixin} from "@/mixins";
import FilterInfo from '@/components/other/FilterInfo';
import policyHeader from "./policyHeader"

const pagination = {
    pageSize: 8,
    showQuickJumper: true,
};
export default {
    name: 'consultation',
    components: {FilterInfo,policyHeader,LayoutFooter},
    mixins: [getDistMixin, listMixin],
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    created() {
        this.getDist('base_grade')
        this.getDist('base_type')
    },
    data() {
        return {
            pagination,
            activeKey: '1',
            policyData: [],
            listUrl:base.pageList,
            queryParam: {grade:'',type:''},
            current: 1,
            total: 10,
            pageSize: 10,
            show:false,
        }
    },
    computed: {
        getFilterInfo() {
            let list = []
            let obj = {}
            let obj1 = {}
            let obj2 = {}
            let obj3 = {}
            obj1['基地等级'] = this.baseGradeArr
            obj['search'] = 'grade'
            obj2['arr'] = obj1
            obj3 = Object.assign(obj, obj2)

            let type = {}
            let type1 = {}
            let type2 = {}
            let type3 = {}
            type1['基地类型'] = this.baseTypeArr
            type['search'] = 'type'
            type2['arr'] = type1
            type3 = Object.assign(type, type2)
            list.push(obj3,type3)
            // list.push(type3)
            return list

        }
    },
    mounted() {
    },
    methods: {
        // changeMsg(id){
        //     console.log(id,'id')
        //     this.policyId = id
        // },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        onMore(id){
            this.show = true
            // this.policyId = id
            this.$router.push({
                path:"/Innovation/components/policyDetail",
                query:{
                    id:id, type:"双创基地"
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
.bannerBox {
    position: relative;
    width: 100%;
    //margin-bottom: 20px;

    .bannerImg {
        width: 100%;
        height: 100%;
    }

    .showMoreButton {
        position: absolute;
        top: 55%;
        left: 21.5%;
        width: 170px;
        height: 56px;
        text-align: center;
        line-height: 56px;
        background-color: #0048c4;
        color: #fff;
        cursor: pointer;
    }
}

.breadBox {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0;
}

.tabBox {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0 20px 0;

    .listBox {
        overflow: hidden;
        padding: 15px 0;

        .leftBox {
            float: left;
            width: 24%;
            height: 170px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .right {
            float: left;
            margin-left: 2%;
            width: 74%;
            font-size: 14px;

            .title {
                padding: 10px 0;
                font-size: 20px;
                color: #333;
                font-weight: 500;
            }

            .content {
                overflow: hidden;
                //margin: 10px 0;
                color: #666;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            .time {
                //margin-top: 22px;
                color: #999;
            }

            .btn {
                width: 132px;
                height: 40px;
                background: white;
                color: #2162e4;
                border: 1px solid #2162e4;
                margin-top: 10px;
            }

            .btn:hover {
                background: #2162e4;
                color: white;
                cursor:pointer;
            }
        }
    }

    :deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab) {
        font-size: 14px;
    }

    :deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active) {
        color: #fff;
        background-color: #1890ff;
    }
}
</style>
